import React from 'react';
import { useTranslation } from "react-i18next";
import { Breadcrumb } from 'antd';

import { useList as useOkeds } from 'modules/oked/hooks';

import * as Grid from "components/Grid";

import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import OkedCard from './components/OkedCard';
import { LoadingOutlined } from '@ant-design/icons';

import cls from "./Oked.module.scss";

const Oked = () => {
  const { t, i18n } = useTranslation();

  const { items, isFetched } = useOkeds({
    enabled: true,
    params: {
      perPage: 1_000_000,
    }
  });

  return (
    <Container>
      <Spacer size={35} />

      <Breadcrumb separator=">">
        {/* <Breadcrumb.Item href='/'>{t('home')}</Breadcrumb.Item> */}
        <Breadcrumb.Item href='/mandatory-requirement/register'>{t('mandatory-requirements')}</Breadcrumb.Item>
        <Breadcrumb.Item>{t('oked')}</Breadcrumb.Item>
      </Breadcrumb>

      <Spacer size={32} />

      <Title align='left' text={t('oked')} />

      <Spacer size={40} />

      <Spacer size={40} />

      {items.length > 0 && isFetched && (
        <Grid.Row gutter={[24, 24]}>
          {items
            .map((item, index) => (
              <Grid.Col span={6} key={item.id} data-aos="fade-in" data-aos-delay={index * 50}>
                <OkedCard
                  id={item.id}
                  name={item.name[i18n.language]}
                  count={item.requirements_count}
                  section={item.code}
                />
              </Grid.Col>
            ))}
        </Grid.Row>
      )}

      {
        items.length === 0 && isFetched && (<div className={cls.noData}>{t('no_data')}</div>)
      }

      {
        !isFetched && (<div className={cls.loading}><LoadingOutlined /></div>)
      }

      <Spacer size={140} />
    </Container>
  )
}

export default Oked;